import { render } from "./GerenciamentoRotasView.vue?vue&type=template&id=1289e178"
import script from "./GerenciamentoRotasView.vue?vue&type=script&lang=js"
export * from "./GerenciamentoRotasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__